import { observable, action, computed, flow, toJS, set, reaction, runInAction } from 'mobx';
import { get, isArray, cloneDeep, isEmpty, intersection } from 'lodash';
import { Toast, Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './QuickBuyServ';
import Util from 'utils';
const { alert } = Modal;

class QuickBuyMod {
  // view层实例
  @observable viewInstance = null;

  // 导航栏商品类型, 1 零售订单、2 复消订单
  @observable orderType = '1';
  @observable orderTypeCoupon = 1;
  @observable allocateCargoScale = [];

  @observable distributionRatio = '';

  @observable discount = '';

  @observable discountList = [];
  // 加了资格购后的门槛金额
  @observable totalPureAmount = 0;
  // 菜单列表
  @observable menuList = [];

  // 每个menu对应的商品列表，格式：{ 类目Id: 对应的productList }, _default为“搜索结果”的id
  @observable menuChildMap = { _default: [] };

  // 所有的商品，格式：{ 商品id: 对应的商品详情（要填充个count和selected进去，记录商品被选数量和是否被选择结算） }
  @observable productMsgMap = {};

  // 当前处于激活状态的菜单id、菜单标题、当前处于激活状态的商品id(后台叫其为itemSerial)
  @observable menuId = '';

  @observable activeKeys = ['', '', ''];

  @observable menuTitle = '';

  @observable detailId = '';

  // 搜索keyword
  @observable keyword = '';

  // 是否为搜索资格购商品
  @observable isQualificationSearch = false;

  // 弹窗显隐：详情-子产品
  @observable showDetail = false;

  // 已选产品列表
  @observable selectedProducts = [];

  @observable tabIndex = 0;

  // 记录已选产品项
  @observable selectedItems = {};

  // 是否参加促销活动
  @observable isJoin = true;

  @observable switchIndexs = [];

  // 是否是去凑单
  @observable isScrape = false;

  // 代客下单会员卡号
  @observable memberCard = '';

  @observable memberId = '';

  // 代客下单的订单类型label
  @observable memberOrderTypeList = [];

  // 店铺配货比例
  @observable storeDistributionList = null;

  // 满赠用到的参数
  // 记录已选赠品项id
  @observable selectedGiftItems = [];

  // 记录已选赠品所有数据
  @observable selectedGiftListItems = [];

  // 当前临时选择的商品列表
  @observable selectedGiftList = [];

  //切换后选择的满赠活动ID
  @observable selectActivityId = '';

  @observable cartIndex = 0;

  @observable giftList = {};

  // 赠品类型，1：实物赠品，2：兑换券类，3：虚拟权益
  @observable giftType = '';

  @observable modalObject = {};

  // 赠送数量
  @observable presentCount = '';

  // 赠送方式，1：全部赠送，2：任选
  @observable presentWay = '';

  // 保存赠品活动id
  @observable actId = '';

  // 记录所有的活动活动id
  @observable allActivityItems = {
    // '0988': {
    //   activityGiftId: '898989'
    // }
  };

  // 确定每一项的时候，生成gKey
  @observable activityDiscountInfoListGkey = [];

  @observable isQuery = false;

  // 资格购列表
  @observable qualificationList = [];
  // 当前tab是否为资格购
  @observable isQualification = false;

  // 记录已选赠品对应的活动id
  @observable giftListActivity = [];

  // query接口返回数据
  @observable queryReturnData = [];

  @observable defaultActivityList = [];

  @observable bizDefaultGiveawayReqDto = {};

  //从外部传入的配货比例列表
  @observable realDistributeRadioList = '';

  //是否展示侧边树
  @observable showLeftTree = false;

  //是否为优惠券的快速购物
  @observable counponQuickBuy = false;

  // 资格购前端隐藏，可以通过跳转链接参与活动
  @observable showFlag = false;

  @observable brandList = []; // 品牌列表

  // 产品信息
  @observable productInfo = {};

  // 多规格商品
  @observable moreSpecificationsData = [];
  // 选中的多规格商品
  @observable checkItem = {};
  @observable skuCheckLists = {};
  @observable skuArray = {};
  @observable isSku = false; // 判断是不是sku子产品
  @observable showSkuModal = false;

  isLoadingTree = false;

  // 资格购活动是否允许取消活动以及必须下复消订单 0-不可取消且只能下复消订单 1-可取消可下任何订单类型
  qualificationUnCancel = false;

  // 客服复制链接标识
  @observable activityLink = '';
  // 左侧分类 0 关闭分类 1资格购分类 2前端类目分类
  @observable leftClassify = '';
  // 存储前端类目分类下 当前资格购详情
  @observable currentQualification = {};
  @observable vipUpgradeActivity = '';
  @observable allowDistributionRatio = '';
  // 自定义页面名称
  @observable webTitle = '';
  // 专题页加入的商品
  @observable topicPageProducts = [];

  @observable specialList = [
    '1405233324965958760',
    '1405233760624120877',
    '1408148009626292238',
    '1405319906349857809',
    '1408429137814928498',
    '1408428817035588706'
  ];
  // 当前卡类型
  @observable currentCardType = null;
  // 当前卡名称
  @observable currentCardTypeName = null;
  // 累计值
  @observable hadAccumulateAmount = 0;

  @observable globalSaleMode = null;

  @observable activityId = '';
  // 享考察
  @observable isXkcActivity = false;
  // 活动状态 1 待生效 2 生效中 3 暂停 4 已失效 5 已禁用
  @observable activityStatus = '';
  // 活动类型
  @observable activityType = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  @action
  changeVals(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @computed
  get isYouxiangClub() {
    const { id } = Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]));
    return this.specialList.includes(id);
  }

  @action
  handleTopicPageProducts({ type, data }) {
    const topicPageProducts = toJS(this.topicPageProducts);
    const index = topicPageProducts.findIndex((pro) => pro.itemId === data.itemId);
    if (index > -1) {
      topicPageProducts.splice(index, 1);
    } else {
      topicPageProducts.push({
        ...data,
        itemSerial: data.itemId
      });
    }

    this.topicPageProducts = topicPageProducts;
  }

  // 检查商品是否必购
  findProductInValidActivity(cartItem, productId) {
    const { activityList = [], mustBuyItemMap = {} } = cartItem || {};
    if (!activityList || !activityList.length || !mustBuyItemMap) {
      return {};
    }
    // 遍历mustBuyItemMap的所有活动
    for (const [activityId, items] of Object.entries(mustBuyItemMap)) {
      // 检查活动是否在activityList中
      if (activityList.some((activity) => activity.activityId === activityId)) {
        // 检查当前活动是否包含目标商品
        const matchingItem = items.find((item) => item.itemId === productId);
        if (matchingItem) {
          return matchingItem;
        }
      }
    }
    return {};
  }

  /**
   * 获取菜单列表
   *
   *
   */
  getMenuList = flow(function* (id) {
    try {
      if (this.keyword) return;
      this.menuList = [];
      let that = this;
      this.getQualificationList(id, function () {
        that.initActiveMenu(id);
      });
    } catch (error) {
      console.log('error', error);
    }
  });

  /**
   * 初始化第一个类目为激活状态
   */
  @action
  initActiveMenu(id) {
    const data = this.menuList;
    if (data.length == 0) {
      return;
    }
    let idObjectParam = {};
    if (!data[0].childrenList || data[0].childrenList.length == 0 || this.leftClassify === 2) {
      this.menuId = data[0].mainId || data[0].id;
      idObjectParam = { ...idObjectParam, mainId: data[0].mainId, id: data[0].id };
      this.menuTitle = data[0].name;
      this.activeKeys = [data[0].id];
    } else if (
      !data[0].childrenList[0].childrenList ||
      data[0].childrenList[0].childrenList.length == 0
    ) {
      this.menuId = data[0].childrenList[0].mainId || data[0].childrenList[0].id;
      idObjectParam = {
        ...idObjectParam,
        mainId: data[0].childrenList[0].mainId,
        id: data[0].childrenList[0].id
      };
      this.menuTitle = data[0].childrenList[0].name;
      this.activeKeys = [data[0].id, data[0].childrenList[0].id];
    } else {
      this.menuId =
        data[0].childrenList[0].childrenList[0].mainId ||
        data[0].childrenList[0].childrenList[0].id;
      idObjectParam = {
        ...idObjectParam,
        mainId: data[0].childrenList[0].childrenList[0].mainId,
        id: data[0].childrenList[0].childrenList[0].id
      };
      this.menuTitle = data[0].childrenList[0].childrenList[0].name;
      this.activeKeys = [
        data[0].id,
        data[0].childrenList[0].id,
        data[0].childrenList[0].childrenList[0].id
      ];
    }
    this.idObjectParam = cloneDeep(idObjectParam);
    //  this.isQualification ? this.getZiGeProductList(this.menuId, this.idObjectParam) : this.getProductList(this.menuId)
    if (this.leftClassify === 2) {
      const id = Util.getQueryString('id');
      this.getCategoryProductList();
      return;
    }
    if (this.leftClassify === 1) {
      this.getZiGeProductList(id, true);
    }
  }

  /**
   * 获取资格购列表
   */
  getQualificationList = flow(function* (activityId, cb) {
    if (this.isLoadingTree) return;
    this.isLoadingTree = true;
    let pars = {
      isPurchasingAgent: 0,
      activityId,
      welfareMall: 1,
      show: this.showFlag ? 1 : 0,
      saleMode: this.isXkcActivity ? '' : this.globalSaleMode || ''
    };
    if (this.memberId) {
      pars.placeUserId = this.memberId;
      pars.isPurchasingAgent = 1;
    } else {
      pars.isPurchasingAgent = 0;
    }

    let { data, resultCode } = yield Serv.getQualificationList(pars);
    this.isLoadingTree = false;
    if (resultCode == 0) {
      this.qualificationList = data;

      let dataS = this.qualificationList.map((item) => ({
        itemType: item.type,
        type: 'isQualification', // 此字段用来标识是资格购
        name: item.activityName,
        id: item.id,
        parentId: 'qualification_id',
        status: 1,
        extension: 2,
        disabled: false,
        code: item.activityCode
      }));
      if (dataS.length > 0 && this.leftClassify !== 2) {
        let it = {
          id: 'qualification_id',
          disabled: false,
          name: '尊享专区',
          childrenList: dataS,
          parentId: get(dataS, 'rootId') || 0,
          status: 1
        };
        this.menuList = [...this.menuList, it];
      }
      cb && cb();
    }
  });

  /**
   * 根据类目id，获取商品列表
   */
  getCategoryProductList = flow(function* () {
    try {
      const id = Util.getQueryString('id');
      const params = {
        id: id,
        dirId: this.menuId === id ? '' : this.menuId
      };
      if (this.globalSaleMode) {
        params.saleMode = this.globalSaleMode;
      }
      if (this.isXkcActivity) {
        params.saleMode = '';
      }
      const res = yield Serv.getCategoryProductList(params);
      let productArr = get(res, 'data');
      console.log('productArrproductArrproductArr', productArr);
      if (Array.isArray(productArr)) {
        productArr.forEach((_val) => {
          for (let item of _val.mediaRespDtoList || []) {
            if (item.fileType === 1) {
              _val.imgUrl = item.path1;
              break;
            }
          }
          _val.itemType = _val.type;
          _val.type = 'isQualification';
          _val.price = _val.discountSalePrice;
          _val.itemSerial = _val.itemId;
          _val.skuSerial = _val.skuId;
          _val.bv = _val.itemBv;
          if (!this.productMsgMap[_val.itemId]) {
            this.productMsgMap[_val.itemId] = {
              vipUpgradeActivity: this.vipUpgradeActivity,
              allowDistributionRatio: this.allowDistributionRatio,
              itemNum: 0,
              selected: false,
              ..._val
            };
          } else {
            this.productMsgMap[_val.itemId] = { ...this.productMsgMap[_val.itemId], ..._val };
          }
          if (_val.itemType == 6) {
            _val.subItemList &&
              _val.subItemList.map((el) => {
                if (!this.productMsgMap[el.itemId]) {
                  this.productMsgMap[el.itemId] = {
                    vipUpgradeActivity: this.vipUpgradeActivity,
                    allowDistributionRatio: this.allowDistributionRatio,
                    itemNum: 0,
                    selected: false,
                    ...el
                  };
                }
              });
            if (!this.skuArray[_val.itemId]) {
              this.skuArray[_val.itemId] = _val.subItemList || [];
            }
          }
        });
        console.log('productMsgMap>>>>', toJS(this.productMsgMap));
        set(this.menuChildMap, { [this.menuId]: productArr });
      }
    } catch (error) {
      console.log('error', error);
    }
  });

  /**
   * 根据id，获取商品列表
   */
  getProductList = flow(function* (id) {
    id = Util.getQueryString('id');
    if (!id) return;
    try {
      // if (!id || id === '_default') { return }
      let params = {
        couponTemplateId: id,
        keyword: Util.getLocalCache('product_searchHistory')
          ? Util.getLocalCache('product_searchHistory')[0]
          : '',
        saleMode: this.isXkcActivity ? '' : this.globalSaleMode || ''
      };
      Util.setLocalCache('product_searchHistory', []);
      if (this.isDiscountMode && this.discount != 2) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }

      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }

      if (this.keyword) {
        params.keyword = this.keyword;
      }

      const { data } = yield Serv.getProductList(params);
      if (Array.isArray(data)) {
        set(this.menuChildMap, { [id]: data });
        let brandList = [];
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          }
          const { itemBrandRespDto } = _val || {};
          const { name, id, code, itemId } = itemBrandRespDto || {};
          const returnIndex = brandList.findIndex((res) => {
            return res.id == id;
          });
          if (!(returnIndex >= 0)) {
            brandList = [...brandList, { name, id, code, itemId }];
          }
        });
        this.brandList = brandList || [];
      }
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 根据id，获取资格购商品列表
   * flag 是否改变别名
   */
  getZiGeProductList = flow(function* (id, flag = true) {
    if (!id) return;
    try {
      const params = {};
      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }
      if (this.globalSaleMode) {
        params.saleMode = this.globalSaleMode || '';
      }
      if (this.isXkcActivity) {
        params.saleMode = '';
      }
      const { data } = yield Serv.getZiGeProductList(id, params);
      let productArr = get(data, 'itemReqDto.itemReqDtos');
      console.log('productArrproductArrproductArr', productArr);
      if (Array.isArray(productArr)) {
        productArr.forEach((_val) => {
          let mainPicUrl = '';
          try {
            if (_val.mainPic) {
              const mainPicArr = JSON.parse(_val.mainPic);
              if (Array.isArray(mainPicArr) && mainPicArr.length > 0) {
                mainPicUrl = mainPicArr[0];
              }
            }
          } catch (e) {
            console.log('mainPic解析失败', e);
          }

          if (mainPicUrl) {
            _val.imgUrl = mainPicUrl;
          } else {
            for (let item of _val.mediaRespDtoList || []) {
              if (item.fileType === 1) {
                _val.imgUrl = item.path1;
                break;
              }
            }
          }
          _val.itemType = _val.type;
          _val.type = 'isQualification';
          _val.price = _val.discountSalePrice;
          _val.itemSerial = _val.itemId;
          _val.skuSerial = _val.skuId;
          _val.bv = _val.itemBv;
          if (!this.productMsgMap[_val.itemId]) {
            this.productMsgMap[_val.itemId] = {
              vipUpgradeActivity: data.vipUpgradeActivity,
              allowDistributionRatio: data.allowDistributionRatio,
              itemNum: _val.isMustBuy ? _val.limitBuyNum : 0,
              selected: false,
              ..._val
            };
          } else {
            this.productMsgMap[_val.itemId] = {
              ...this.productMsgMap[_val.itemId],
              ..._val,
              itemNum: _val.itemNum || (_val.isMustBuy ? _val.limitBuyNum : 0),
              selected: _val.selected || _val.isMustBuy
            };
          }
          if (_val.isMustBuy) {
            this.changeCount(_val, parseInt(_val.limitBuyNum), false);
          }
          if (_val.itemType == 6) {
            _val.subItemList &&
              _val.subItemList.map((el) => {
                if (!this.productMsgMap[el.itemId]) {
                  this.productMsgMap[el.itemId] = {
                    vipUpgradeActivity: data.vipUpgradeActivity,
                    allowDistributionRatio: data.allowDistributionRatio,
                    itemNum: 0,
                    selected: false,
                    ...el
                  };
                }
              });
            if (!this.skuArray[_val.itemId]) {
              this.skuArray[_val.itemId] = _val.subItemList || [];
            }
          }
        });
        set(this.menuChildMap, { [id]: productArr });
      }

      // 没有侧边栏的批量购物，资格购活动是否允许取消活动以及必须下复消订单 0-不可取消且只能下复消订单 1-可取消可下任何订单类型
      this.qualificationUnCancel = !this.showLeftTree && data.canCancel === 0;
      // 没有侧边栏/前端类目侧边栏 notCancelTag 后管配置项 1不可取消 0可取消
      if ([0, 2].includes(data.baseReqDto.leftClassify) && data.baseReqDto.notCancelTag === 1) {
        this.qualificationUnCancel = true;
      }
      this.leftClassify = data.baseReqDto.leftClassify;
      flag && (this.webTitle = data.baseReqDto.webTitle || '尊享专区');
      // 左侧显示前端类目
      if (data.baseReqDto.leftClassify === 2) {
        this.currentQualification = { ...data.baseReqDto, id: data.id };
        this.vipUpgradeActivity = data.vipUpgradeActivity;
        this.allowDistributionRatio = data.allowDistributionRatio;
        this.menuList = [
          {
            id: Util.getQueryString('id'),
            disabled: false,
            name: '全部商品',
            childrenList: [],
            parentId: 0,
            status: 1
          },
          ...(data.itemReqDto.dirTreeList || [])
        ];
        this.initActiveMenu();
      }
      if (data.baseReqDto.leftClassify === 1 && flag) {
        let list = toJS(this.menuList);
        list.map((item) => {
          if (item.id === 'qualification_id') {
            item.name = this.webTitle;
          }
        });
        this.menuList = list;
      }
    } catch (error) {
      // flag && (this.webTitle = '尊享专区');
    }
  });

  /**
   * 关键词搜索普通商品
   */
  toSearch = flow(function* (key, id) {
    try {
      let params = { keyword: key, couponTemplateId: id };
      if (this.isDiscountMode) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }
      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }
      if (this.globalSaleMode) {
        params.saleMode = this.globalSaleMode || '';
      }
      if (this.isXkcActivity) {
        params.saleMode = '';
      }
      const { data } = yield Serv.getProductList(params);
      if (Array.isArray(data)) {
        set(this.menuChildMap, { _default: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 关键词搜索资格购商品
   */
  toSearch_2 = flow(function* (key) {
    try {
      let qualificationList = this.qualificationList;
      if (this.leftClassify === 2) {
        qualificationList = [this.currentQualification];
      }
      const activityIdList = qualificationList.map((item) => item.id);
      const params = {
        isPurchasingAgent: this.memberId ? 1 : 0,
        activityIdList,
        welfareMall: 1,
        show: this.showFlag ? 1 : 0
      };
      if (this.memberId) params.placeUserId = this.memberId;
      if (this.isDiscountMode) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }
      if (this.globalSaleMode) {
        params.saleMode = this.globalSaleMode || '';
      }

      if (this.isXkcActivity) {
        params.saleMode = '';
      }

      let { data } = yield Serv.searchQualification(params, key || '');

      if (Array.isArray(data)) {
        data.forEach((_val) => {
          for (let item in _val.mediaRespDtoList || []) {
            if (item.fileType === 1) {
              _val.imgUrl = item.path1;
              break;
            }
          }
          _val.itemType = _val.type;
          _val.type = 'isQualification';
          _val.price = _val.discountSalePrice;
          _val.itemSerial = _val.itemId;
          _val.skuSerial = _val.skuId;
          _val.bv = _val.discountBvBigDecimal;
          if (!this.productMsgMap[_val.itemId]) {
            this.productMsgMap[_val.itemId] = {
              vipUpgradeActivity: data.vipUpgradeActivity,
              allowDistributionRatio: data.allowDistributionRatio,
              itemNum: 0,
              selected: false,
              ..._val
            };
          } else {
            _val.allocateCargoScale = this.productMsgMap[_val.itemId]['allocateCargoScale'];
            this.productMsgMap[_val.itemId] = { ...this.productMsgMap[_val.itemId], ..._val };
          }
        });
        set(this.menuChildMap, { _default: data });
      }
    } catch (err) {
      console.log('😍====>111', err);
    }
  });

  @computed
  get ldFloor() {
    return Stores.AppMod.isLD && this.orderType == '1' && this.distributionRatio > 1;
  }

  // 已选是否有店长物料
  @computed
  get isSelectListHasQualify() {
    let flag = false;
    return flag;
  }

  // 已选是否有vip复购
  @computed
  get isSelectListHasVip() {
    let flag = false;
    for (let key in this.productMsgMap) {
      let item = this.productMsgMap[key];
      if (item.selected && !!item.vipUpgradeActivity && item.itemNum > 0) {
        flag = true;
      }
    }
    return flag;
  }

  /**
   * 活动下单，通用提示处理
   */
  handleActivityCommonTip(title = '提示', resultMsg, callback) {
    alert(title, resultMsg, [
      {
        text: '确认',
        onPress: () => {}
      }
    ]);
  }

  /**
   * 增加商品
   */
  @action
  changeCount(item, value, sign, isSku, isFromTopic) {
    this.isSku = isSku || false;
    console.log('this.getItemDisabled(item, 1, isSku)??', isFromTopic);
    if (this.getItemDisabled(item, 1, isSku, isFromTopic)) {
      return;
    }
    if (sign) {
      this.detailId = item.itemSerial;
      this.showDetail = true;
      return;
    }
    // if (item.type != 'isQualification') {
    // }
    let obj = toJS(this.productMsgMap);
    obj = JSON.parse(JSON.stringify(obj));
    if (+item === 0) {
      // 清楚多规格临时数量
      Object.keys(obj).forEach((res) => {
        if (obj[res].itemNumFu) {
          obj[res].itemNumFu = 0;
        }
      });
      this.productMsgMap = obj;
      return;
    }
    if (sign === 0) {
      // 多规格商品临时赋值逻辑
      obj[item.itemSerial].itemNumFu = value;
      if (JSON.stringify(item.selectObject) !== '{}') {
        obj[item.selectObject.itemSerial] = item.selectObject;
        obj[item.selectObject.itemSerial].itemNumFu = value;
      }
    } else {
      if (+value === -1) {
        // 多规格商品确认逻辑
        if (!isEmpty(item.selectObject) && JSON.stringify(item.selectObject) !== '{}') {
          obj[item.selectObject.itemSerial] = item.selectObject;
          obj[item.selectObject.itemSerial].itemNum = obj[item.itemSerial].itemNumFu;
          obj[item.selectObject.itemSerial].fatherItemSerial = item.itemSerial;
          let newChildList = obj[item.itemSerial].childList.map((res) => {
            if (res.itemSerial == item.selectObject.itemSerial) {
              res.itemNumNew = obj[item.itemSerial].itemNumFu;
            }
            return res;
          });
          // obj[item.itemSerial].itemNumFu = 0;
          // obj[item.selectObject.itemSerial].itemNumFu = 0;
          let allValue = 0;
          newChildList.forEach((res) => {
            allValue += res.itemNumNew || 0;
          });
          obj[item.itemSerial].itemNum = allValue; // 这个总和需要计算
        }
      } else {
        // 普通商品逻辑
        if (isSku) {
          obj[item.itemId].itemSerial = item.itemId;
          obj[item.itemId].itemNum = value;
          obj[item.itemId].selected = true;
          obj[item.itemId].type = 'isQualification';
          obj[item.itemId].skuSerial = item.skuId;
          obj[item.itemId].price = item.salePrice;
        } else if (!obj[item.itemId] && item.itemId) {
          obj[item.itemId] = item;
          obj[item.itemId].itemNum = value;
          obj[item.itemId].selected = true;
        } else {
          obj[item.itemSerial].itemNum = value;
          obj[item.itemSerial].selected = true;
        }
      }
    }
    this.productMsgMap = obj;
  }

  /**
   * 减少商品
   */
  @action
  sub(e, itemSerial) {
    let item = this.productMsgMap[itemSerial];
    if (item.type != 'isQualification') {
      if (this.getItemDisabled(item)) {
        return;
      }
    }
    e.stopPropagation();
    let obj = Object.assign({}, this.productMsgMap);
    if (obj[itemSerial].itemNum <= 0) return;
    obj[itemSerial].itemNum--;
    if (obj[itemSerial] <= 0) {
      obj[itemSerial].selected = false;
    }
    this.productMsgMap = obj;
  }

  getItemDisabled(item, num, isSku, isFromTopic) {
    // const { itemProperties, distributionRatio } = item || {};
    // console.log(item, isSku );
    // debugger
    // 资格购 - 商品详情/专题 的加入选购 跳过下面的逻辑
    if (isFromTopic) return false;
    const {
      itemProperties,
      propertiesDistributionRatios,
      allowDiscount,
      type,
      distributionRatio: itemDistributionRatio,
      allocateCargoScale
    } = item || {};
    let distributionRatio = JSON.parse(propertiesDistributionRatios || '{}')[this.orderType];

    if (this.isDiscountMode) {
      return !(this.discount == 1 || allowDiscount);
    }
    let returnValue =
      !itemProperties ||
      itemProperties.indexOf(`${this.orderType}`) == -1 ||
      !distributionRatio ||
      distributionRatio.indexOf(`${this.distributionRatio}`) == -1;
    if (type === 'isQualification' || !!isSku) {
      console.log('returnValue>>>>', type, allocateCargoScale);
      allocateCargoScale &&
        (returnValue = allocateCargoScale.indexOf(`${this.distributionRatio}`) == -1);
      if (returnValue && num) {
        this.tipInfo(returnValue, num, '该产品不支持当前比例');
      }
    } else {
      this.tipInfo(returnValue, num, '该产品不支持当前类型或比例');
    }
    return returnValue;
  }

  tipInfo = (returnValue, num, message) => {
    if (returnValue && num) {
      Modal.alert('提示', message, [
        {
          text: '确定',
          onPress: () => {}
        }
      ]);
    }
  };

  /**
   * 选择结算商品
   */
  @action
  selectProduct(itemSerial) {
    let item = this.productMsgMap[itemSerial];
    if (this.getItemDisabled(item)) {
      return;
    }
    let obj = Object.assign({}, this.productMsgMap);
    obj[itemSerial].selected = !obj[itemSerial].selected;
    this.productMsgMap = obj;
  }

  @action
  changeSelectedGift(id, isSelected, activityId, thisCartIndex) {
    let value = JSON.parse(JSON.stringify(this.selectedGiftItems));
    value = Array.from(value);
    let object = value[+thisCartIndex] || {};
    object[activityId] = object[activityId] || {};
    id && (object[activityId][id] = !isSelected);
    const returnValue = Object.values(object[activityId]).findIndex((item) => item);
    if (returnValue === -1) {
      Toast.info('赠品至少选择一个哦');
      return false;
    }
    value[+thisCartIndex] = object;
    this.selectedGiftItems = value;
    return true;
  }

  /**
   * 获取满赠列表
   */
  getActivityGiftList = flow(function* (id, thisCartIndex) {
    try {
      const trueKeys = Object.keys(this.selectedItems).filter(
        (key) => this.selectedItems[key] === true
      );

      // 处理 activityIds：字符串或逗号分割字符串转数组
      let activityIds = id.activityIds;
      if (typeof activityIds === 'string') {
        activityIds = activityIds.includes(',') ? activityIds.split(',') : [activityIds];
      }

      let { data, resultCode } = yield Serv.getActivityIdsGiftList({
        activityIds: activityIds,
        saleMode: this.isXkcActivity ? '' : this.globalSaleMode || '',
        itemList:
          this.selectedProducts[thisCartIndex]['itemList'] &&
          this.selectedProducts[thisCartIndex]['itemList'].filter((fl) =>
            trueKeys.includes(fl.itemSerial)
          )
      });

      let AllGiftList = {};
      let modalObject = {};
      let modalObjectList = this.modalObject || [];
      let AllGiftListActivity = this.giftListActivity || [];
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftItemList = get(datas, 'giftItemList') || [];
          let couponList = get(datas, 'couponList') || [];
          let rightsList = get(datas, 'rightsList') || [];
          let giftType = get(datas, 'giftType');
          let activityId = get(datas, 'activityId');
          let presentCount = get(datas, 'presentCount');
          let presentWay = get(datas, 'presentWay');
          let random = get(datas, 'random');
          let shared = get(datas, 'shared');
          let blessingBagAlias = get(datas, 'blessingBagAlias');
          let blessingBagImg = get(datas, 'blessingBagImg');
          let theGiftList;
          if (+giftType === 5) {
            theGiftList = [...giftItemList, ...couponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
            });
          } else {
            theGiftList = [giftItemList, couponList, rightsList][giftType - 1];
          }
          const newTheGiftList = theGiftList.map((itemVal) => {
            itemVal.presentWay = presentWay;
            itemVal.presentCount = presentCount;
            itemVal.random = random;
            itemVal.blessingBagAlias = blessingBagAlias;
            itemVal.blessingBagImg = blessingBagImg;
            return itemVal;
          });
          AllGiftList[activityId] = newTheGiftList;
          let thisModalObject = {
            giftType,
            presentCount,
            presentWay,
            random,
            shared,
            blessingBagAlias,
            blessingBagImg
          };
          modalObject[activityId] = thisModalObject;
          if (presentWay == 1) {
            theGiftList.forEach((item) => {
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
              this.changeSelectedGift(
                effectiveType === 1 ? item.itemSerial : item.id,
                false,
                activityId,
                thisCartIndex
              );
            });
          }
          if (presentWay == 2 || presentWay != 1) {
            // 限制数量的自上而下选中可选赠品
            let count = 0;
            this.selectedGiftItems[thisCartIndex] &&
              this.selectedGiftItems[thisCartIndex][activityId] &&
              Object.values(this.selectedGiftItems[thisCartIndex][activityId]).forEach((res) => {
                res && count++;
              });
            if (count === 0) {
              theGiftList.forEach((item, index) => {
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
                if (index < (random ? theGiftList.length : presentCount)) {
                  this.changeSelectedGift(
                    effectiveType === 1 ? item.itemSerial : item.id,
                    false,
                    activityId,
                    thisCartIndex
                  );
                }
              });
            }
          }
        });
        modalObjectList[thisCartIndex] = modalObject;
        this.modalObject = modalObjectList;
        AllGiftListActivity[thisCartIndex] = AllGiftList;
        this.giftList = AllGiftList;
        this.giftListActivity = AllGiftListActivity;
        if (thisCartIndex) {
          this.cartIndex = thisCartIndex;
        }
        this.handleSelectedGiftList(thisCartIndex, AllGiftList);
      }
    } catch (error) {
      console.log(error, '获取满赠列表失败');
    }
  });

  /**
   * 获取加价购信息
   */
  getIncPriceShopMsg = flow(function* (gKey) {
    const list = [];
    const cartItem = this.selectedProducts.find((group) => group.gKey == gKey);
    const { activityList, itemList } = cartItem;
    // 如果活动不包含加价购物，则返回
    const hasIncPriceAct = activityList.some((activity) => activity.activityType == 4);
    if (!hasIncPriceAct) return;
    if (activityList && activityList.length > 0 && this.isJoin) {
      const activityInfoReqDtoList = [];
      for (const item of itemList) {
        if (this.selectedItems[item.itemSerial]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityInfoReqDtoList.length > 0) {
        list.push({
          activityInfoReqDtoList: activityList,
          itemfoReqDtoList: activityInfoReqDtoList,
          distributionRatio: this.distributionRatio,
          orderType: this.orderType
        });
      }
    }
    if (list.length == 0) return;

    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      orderType: this.orderType,
      dgCardno: this.memberCard || ''
    };
    try {
      const { data } = yield Serv.getIncPriceShopMsg(params);
      let list = [...this.selectedProducts];
      let cartItemIndex = -1;
      this.selectedProducts.some((group, index) => {
        if (group.gKey == gKey) {
          cartItemIndex = index;
          return true;
        }
      });
      // 是否是盲盒活动
      const isRand = get(data, 'random', 0);
      list[cartItemIndex].incPriceShop = {
        items: get(data, 'itemRespDtoList', []).map((item, i) => ({
          ...item,
          itemNum: isRand ? (i === 0 ? get(data, 'increment', 0) : 0) : 1,
          isSelected: !!isRand && i === 0
        })),
        rand: isRand,
        shared: get(data, 'shared', 1),
        blessingBagAlias: get(data, 'blessingBagAlias', ''),
        blessingBagImg: get(data, 'blessingBagImg', ''),
        maxIncPriceNum: get(data, 'increment', 0),
        incPriceMoney: get(data, 'priceIncrease', 0),
        incPriceType: get(data, 'priceIncreaseType', 0)
      };
      this.selectedProducts = list;
      this.viewInstance.forceUpdate();
    } catch (error) {}
  });

  // 正向选择赠品 (主动从赠品弹框选择赠品)
  @action
  handleSelectedGiftList(thisCartIndex, AllGiftList) {
    let AllSelectedGiftList = {};
    let selectedGiftItems = toJS(this.selectedGiftItems);
    console.log(selectedGiftItems, 'selectedGiftItemsselectedGiftItems');
    let selectedValue = [...this.selectedGiftListItems];
    let giftKeys = Object.keys(AllGiftList || toJS(this.giftList));
    const itemValue = selectedGiftItems[thisCartIndex];
    giftKeys.forEach((items, index) => {
      // 选中的满赠礼品循环[[满赠1],[满赠2]]
      let selectedGiftList = [];
      (AllGiftList || toJS(this.giftList))[items].forEach((item) => {
        const effectiveType = item.resolvedGiftType !== undefined ? item.resolvedGiftType : item.giftType;
        let id = effectiveType == 1 ? item.itemSerial : item.id;
        itemValue[items] &&
          Object.keys(itemValue[items]).forEach((it) => {
            // 循环已选择的赠品
            if (itemValue[items][it] && it == id) {
              // 选中状态的赠品和满赠的赠品相同;
              selectedGiftList.push(item); // 存储其中 一个满赠活动的满赠的产品
            }
          });
      });
      AllSelectedGiftList[items] = selectedGiftList;
    });
    // 将该组下的多个满赠赋值到该分组内容下
    if (+thisCartIndex >= 0) {
      selectedValue[thisCartIndex] = AllSelectedGiftList;
    } else {
      selectedValue[this.cartIndex] = AllSelectedGiftList;
    }
    this.selectedGiftListItems = selectedValue;
  }

  // 反向选择赠品
  @action
  handleSelectedGiftListFan = (index, activityId) => {
    // cartIndex 记录是哪个分组的
    this.cartIndex = index;
    if (!Array.isArray(activityId) && activityId.length > 0) {
      activityId = [activityId];
    }
    if (Array.isArray(activityId) && activityId.length > 0) {
      activityId.length === 1
        ? this.getActivityGiftList({ activityIds: activityId[0] }, index)
        : this.getActivityGiftList({ activityIds: activityId.join(',') }, index);
    }
    // let value = {};
    // let valueList = JSON.parse(JSON.stringify(toJS(this.selectedGiftListItems)));
    // if (
    //   valueList[index] &&
    //   valueList[index].length > 0
    // ) {
    //   // 处理选择的赠品
    //   valueList[index][activityId] &&
    //   valueList[index][activityId].forEach(item => {
    //     value[index][activityId][item.itemSerial] = true;
    //   });
    // }
    // this.selectedGiftItems = value;
  };

  /**
   * 产品列表
   */
  @computed
  get productList() {
    const menuChildMap = toJS(this.menuChildMap);
    console.log('menuChildMap??????', menuChildMap, this.menuId);
    return menuChildMap[this.menuId] || [];
  }

  @action
  changeOrderType(orderType) {
    this.orderType = orderType;
    const { hasDisable } = this.getSelectedData();
    if (hasDisable) {
      Toast.info('因订单类型变化，部分产品不可以下单', 3, null, false);
    }
  }

  getSelectedData() {
    let selectedList = Object.values(toJS(this.productMsgMap)).filter((_val) => {
      // return _val.itemNum > 0 && !_val.itemNumFu && +_val.itemType !== 5;
      return _val.itemNum > 0 && +_val.itemType !== 5;
    });
    let hasDisable = false;
    selectedList = selectedList.map((_val) => {
      if (_val.skuId) {
        _val.skuSerial = _val.skuId;
      }
      if (_val.type !== 'isQualification' && !this.isSku) {
        if (this.getItemDisabled(_val)) {
          _val.selected = false;
          hasDisable = true;
        }
        return _val;
      }
      if (_val.type == 'isQualification' || this.isSku) {
        _val.selected = true;
        return _val;
      }
    });
    return { hasDisable, selectedList };
  }

  /**
   * 所选的商品
   */
  @computed get selectedList() {
    const { selectedList } = this.getSelectedData();

    return selectedList;
  }

  /**
   * 合计金额、bv
   */
  @computed
  get totals() {
    let totalNum = 0;
    let totalAmount = 0;
    let totalBv = 0;
    let totalSelectedCount = 0; // 已选产品列表的选中产品数量

    this.selectedList.forEach((item) => {
      if (item.selected) {
        totalNum += parseInt(item.itemNum);
      }
    });
    console.log('this.selectedList==', this.selectedList, totalNum);
    for (const cartItem of this.selectedProducts) {
      const { activityList = [], itemList } = cartItem;
      // 分组有产品选择
      let flag = false;
      for (const item of itemList) {
        const { itemSerial, price, itemNum, bv, discountBv, discount, promotionBv } = item;
        if (this.selectedItems[itemSerial]) {
          flag = true;
          totalAmount += price * itemNum;
          // totalBv = totalBv + bv * itemNum - (discountBv || 0);
          totalBv = totalBv + (promotionBv >= 0 ? promotionBv : bv) * itemNum;
          // this.ldFloor ? (totalBv = totalBv + promotionBv * itemNum) : (totalBv = totalBv + bv * itemNum - (discountBv || 0));
          totalSelectedCount += Number(itemNum);
          if (this.isDiscountMode) {
            totalAmount -= discount || 0;
          }
        }
      }
      if (!this.isDiscountMode && flag && activityList && activityList.length > 0) {
        for (const item of activityList) {
          const {
            achieve, // 是否满足
            reduceAmount // 优惠金额，如 已减100.00 返回 100.00
          } = item;
          if (achieve) {
            totalAmount -= reduceAmount || 0;
          }
        }
      }
    }
    this.incPriceTotal.map((item, index) => {
      totalSelectedCount += item.count;
      totalAmount += item.money;
    });

    // this.selectedProducts.forEach((item, index) => {
    //   this.selectedGiftListItems[index] &&
    //   Object.values(this.selectedGiftListItems[index]).forEach((item, index) => {
    //         if (item.giftCount && item.giftType === 1) {
    //           totalSelectedCount += item.giftCount;
    //         }
    //     });
    // });

    return {
      totalNum,
      totalAmount,
      totalBv: parseInt(totalBv),
      totalSelectedCount
    };
  }

  // 是否折扣模式
  @computed
  get isDiscountMode() {
    return false;
    // return Object.keys(this.discountList).length > 0
  }
  // 是否显示资格购-干细胞配货比例
  @computed
  get isShopMasterMode() {
    return false;
    return Object.keys(this.masterDistributionList).length > 0;
  }

  // 资格购-干细胞配货比例
  @computed
  get masterDistributionList() {
    // let obj = {}
    // let arr = []
    // for (const cartItem of this.selectedProducts) {
    //   if (cartItem.activityList) {
    //     for (const item of cartItem.activityList) {
    //       if (item.allowDistributionRatio) {
    //         arr = [...arr, ...item.allocateCargoScale.split(',')]
    //       }
    //     }
    //   }
    // }
    // if (arr.length > 0) {
    //   let newArr = new Set(arr)
    //   newArr = Array.from(newArr).map(item => {
    //     return {
    //       label: `1:${item} 配货`,
    //       value: item
    //     }
    //   })
    //   if (newArr.length > 1) {
    //     obj[1] = [{label: '未选择', value: "-1"}, ...newArr]
    //     obj[2] = [{label: '未选择', value: "-1"}, ...newArr]
    //   } else {
    //     obj[1] = newArr
    //     obj[2] = newArr
    //   }
    //   return obj
    // } else {
    return {};
    // }
  }

  @computed
  get orderTypeList() {
    // const all = [
    //   {label: '零售订单', value: 1},
    //   {label: '复消订单', value: 2}
    // ]
    const userInfo = Stores.AppMod.userInfo || {};
    const orderLabelList = this.memberCard
      ? this.memberOrderTypeList
      : (userInfo && userInfo.orderLabelList) || [];
    console.log('orderLabelList>>>>', this.memberCard, toJS(orderLabelList));
    let type1 = orderLabelList.filter((v) => v.value == 1);
    let type2 = orderLabelList.filter((v) => v.value == 2);
    if (!this.counponQuickBuy) {
      if (!type1.length) {
        type1 = [{ label: '零售订单', value: 1 }];
      }

      if (!type2.length) {
        type2 = [{ label: '复消订单', value: 2 }];
      }
    }
    let t1 = { label: type1[0] ? type1[0].label : '', value: 1 };
    let t2 = { label: type2[0] ? type2[0].label : '', value: 2 };
    const mapType = {
      1: t1,
      2: t2
    };
    const mapOrderTypeCoupon = {
      0: [t1, t2],
      1: [t1],
      2: [t2]
    };

    let list = orderLabelList.map((item) => ({ label: item.label, value: item.value }));
    const valueUserOrderTypeV = list.map((v) => v.value);
    console.log(this.orderTypeCoupon, 'orderTypeCoupon');
    const couponOrderTypeV =
      Array.isArray(mapOrderTypeCoupon[this.orderTypeCoupon]) &&
      mapOrderTypeCoupon[this.orderTypeCoupon].map((v) => v.value);
    const targetV = this.counponQuickBuy
      ? intersection(valueUserOrderTypeV, couponOrderTypeV)
      : couponOrderTypeV;
    console.log(targetV, '-->');
    list = Array.isArray(targetV) && targetV.length > 0 ? targetV.map((tv) => mapType[tv]) : [];

    if (this.isVipRebuy) {
      list.push({ value: '10', label: 'VIP复购订单' });
    }
    if (this.globalSaleMode === 2) {
      list = [{ label: '零售订单', value: 1 }];
    }
    console.log(toJS(list));
    return list.filter((v) => v.label != '');
  }

  @computed
  get distributeRadioList() {
    const generateDesc = (v) => ({
      label: `1:${v} 配货`,
      orderMinAmount: 0,
      orderMinBv: null,
      value: v
    });
    let distributionObj =
      this.realDistributeRadioList || Stores.AppMod.userInfo.distributionRatioList;
    let intersectionArr = intersection(
      Object.keys(distributionObj || {}),
      this.orderTypeList.map((v) => v.value + '')
    );
    // let orderArr
    let dis = intersectionArr.map((i) =>
      Array.isArray(toJS(distributionObj[i]))
        ? distributionObj[i].map((m) => m.value).filter((f) => f != '-1')
        : []
    );
    let resObj = {};
    intersectionArr.forEach((f, ind) => {
      resObj[f] = [
        // { label: '未选择', orderMinAmount: 0, value: '-1' },
        ...intersection(dis[ind], toJS(this.allocateCargoScale)).map((m) => generateDesc(m))
      ];
    });
    console.log(
      intersectionArr,
      toJS(distributionObj),
      dis,
      resObj,
      'intersectionArr',
      toJS(this.allocateCargoScale)
    );
    for (let k in resObj) {
      resObj[k] &&
        resObj[k].forEach((el) => {
          toJS(distributionObj)[k] &&
            toJS(distributionObj)[k].find((ele) => {
              if (el.value == ele.value) {
                el.label = ele.label;
              }
            });
        });
    }
    return resObj;
    // return Stores.AppMod.userInfo.distributionRatioList || [];
  }
  // 顶部分类列第二栏
  @computed
  get col2List() {
    let col2 = {};
    if (this.isShopMasterMode) {
      col2 = this.masterDistributionList;
    } else {
      if (this.isDiscountMode) {
        col2 = this.discountList;
      } else {
        if (this.memberCard) {
          col2 = this.storeDistributionList;
        } else {
          col2 = this.distributeRadioList;
        }
      }
    }
    if (this.globalSaleMode === 2) {
      col2 = this.distributeRadioList;
    }
    return col2;
  }

  @computed
  get cartTypeList() {
    // 设置children
    const handleTypeList = (objList) => {
      let arr = [];
      if (objList && Object.keys(objList).length > 0) {
        this.orderTypeList.forEach((item) => {
          let obj = {};
          obj.value = item.value;
          obj.label = item.label;
          // obj.children = this.distributeRadioList[item.value];
          obj.children = objList[item.value];
          arr.push(obj);
        });
      }
      return arr;
    };
    let pickerList = handleTypeList(toJS(this.col2List));

    return pickerList;
    // return [this.orderTypeList, this.distributeRadioList['1']];
  }

  @computed get hideTitle() {
    if (Stores.AppMod.userInfo.systemType === 0) {
      return false;
    }
    const { cartTypeList } = this;

    const newCartTypeList = cartTypeList.filter((item) => {
      const { children } = item || {};
      if (Array.isArray(children) && children.length > 0) {
        return item;
      }
    });

    if (Array.isArray(newCartTypeList) && newCartTypeList.length === 1) {
      const { children } = newCartTypeList[0];
      const filterValue = children.filter((res) => {
        const { value } = res || {};
        if (+value !== -1) {
          return res;
        }
      });
      if (Array.isArray(filterValue) && filterValue.length === 1) {
        return true;
      }
    }
    return false;
  }

  /**
   * 处理配送比例，根据接口返回设置
   */
  @action
  handleDistributionRatio() {
    if (!this.distributionRatio) {
      if (this.distributeRadioList && Object.keys(this.distributeRadioList).length > 0) {
        let distributeRadioList =
          this.distributeRadioList['1'] || this.distributeRadioList['2'] || [];
        let distributionRatio =
          distributeRadioList && distributeRadioList[0] && distributeRadioList[0].value;
        if (
          Stores.AppMod.userInfo.systemType === 0
            ? distributeRadioList.length === 2
            : this.hideTitle && distributeRadioList.length >= 2
        ) {
          distributionRatio =
            distributeRadioList && distributeRadioList[1] && distributeRadioList[1].value;
        }
        this.distributionRatio = this.isVipRebuy ? 1 : distributionRatio;
      } else {
      }
    }
  }

  /**
   * 是否vip复购
   */
  @computed
  get isVipRebuy() {
    if (!this.selectedProducts || this.selectedProducts.length == 0) {
      return false;
    }
    let flag = false;
    for (const productItem of this.selectedProducts) {
      if (productItem.activityList) {
        for (const item of productItem.activityList) {
          if (item.vipUpgradeActivity === 1) {
            flag = true;
            break;
          }
        }
      }
    }

    return flag;
  }

  @computed
  get cartTypeText() {
    let txt = '';
    const handleCartTypeText = (listObj) => {
      let text = '';
      if (listObj && Object.keys(listObj).length > 0) {
        for (let i = 0; i < this.orderTypeList.length; i++) {
          if (`${this.orderType}` == this.orderTypeList[i].value) {
            text = this.orderTypeList[i].label;
            break;
          }
        }
        let checkItem =
          this.isDiscountMode && !this.isShopMasterMode
            ? `${this.discount}`
            : `${this.distributionRatio}`;
        if (listObj[this.orderType]) {
          for (let i = 0; i < listObj[this.orderType].length; i++) {
            if (checkItem == listObj[this.orderType][i].value) {
              text = `${text}，${listObj[this.orderType][i].label}`;
              break;
            }
          }
        }
      }

      return text;
    };
    txt = handleCartTypeText(toJS(this.col2List));
    return this.isVipRebuy ? 'VIP复购订单' : txt;
  }
  // 店长最大折扣
  @computed
  get maxMasterDR() {
    let arr = [];
    this.selectedList.map((item) => {
      if (item['allocateCargoScale']) {
        arr = [...arr, item['allocateCargoScale'].split(',')];
      }
    });
    return Math.max(...arr);
  }

  /**
   * 不参与促销活动，计算出普通商品组数据
   */
  @computed
  get selectedProductsForSection() {
    let itemList = [];
    return this.selectedProducts.map((section) => {
      return { ...section, activityList: [] };
    });
  }

  /**
   * 获取已选产品列表
   */
  getSelectedProducts = flow(function* () {
    const { selectedList } = this.getSelectedData();
    if (
      !selectedList ||
      selectedList.length == 0 ||
      !this.orderType ||
      (!this.distributionRatio && !this.discount)
    ) {
      this.selectedProducts = [];
      return;
    }

    Toast.loading('加载中...');
    // vip复购订单，按照零售订单请求
    const orderType = this.orderType == '10' ? '1' : this.orderType;
    try {
      const { data } = yield Serv.getSelectedProducts(
        selectedList,
        orderType,
        this.distributionRatio,
        this.memberCard,
        this.discount,
        this.showFlag,
        this.leftClassify,
        this.globalSaleMode || ''
      );
      Toast.hide();

      let selectedProducts = data || [];
      this.selectedProducts = selectedProducts;
      this.allActivityItems = {};
      this.selectedProducts = this.addActivityProductsKeys(toJS(this.selectedProducts));

      // 对已选的分组，进行请求加价购
      this.selectedProducts.forEach((products, index) => {
        products.itemList.forEach((item, itemIndex) => {
          if (this.selectedItems[item.id]) {
            this.getIncPriceShopMsg(this.selectedProducts[index].gKey);
          }
          const { isMustBuy, limitBuyNum } = this.findProductInValidActivity(
            this.selectedProducts[index],
            item.itemSerial
          );
          if (isMustBuy && item.itemNum < limitBuyNum && this.isJoin) {
            item.itemNum = limitBuyNum;
            this.changeItemNum(item.itemNum, index, itemIndex, item.itemSerial);
            // this.changeCount(item, item.itemNum, false);
          }
        });
      });
      // vip复购默认1:1
      if (this.isVipRebuy && this.orderType != '10' && this.globalSaleMode != 2) {
        this.orderType = '10';
        this.distributionRatio = 1;
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        this.distributionRatio = '1';
        this.getSelectedProducts();
      }

      this.getDiscountBatch();
    } catch (error) {
      Toast.hide();
    }
  });

  /**
   * 获取产品项是否可选
   * retailOrderTypeStatus 是否支持零售订单类型(1：支持 0：不支持)
   * monthlyOrderTypeStatus 是否支持复消订单(1：支持 0：不支持)
   */
  getItemCanSelect(item) {
    const {
      retailOrderTypeStatus,
      monthlyOrderTypeStatus,
      limitNum,
      itemStatus,
      allowDiscount,
      distributionRatio
    } = item;

    if (this.onManaging) {
      return true;
    }
    if (
      this.isDiscountMode &&
      !(allowDiscount || this.discount == 1) &&
      !this.isSelectListHasQualify
    ) {
      return false;
    }
    return (
      ((this.orderType == '1' && retailOrderTypeStatus == 1) ||
        (this.orderType == '2' && monthlyOrderTypeStatus == 1) ||
        this.orderType == '10') &&
      `${itemStatus}` == '1' &&
      // (distributionRatio
      //   ? distributionRatio.indexOf(this.distributionRatio) >= 0
      //   : false) &&
      (limitNum == null ? true : limitNum > 0)
    );
  }

  @action
  onCartTypePick(value) {
    this.orderType = value[0];
    if (this.isDiscountMode && !this.isShopMasterMode) {
      this.discount = value[1];
    } else {
      this.distributionRatio = value[1];
    }
    // 清除已经选择的赠品
    this.selectedGiftListItems = [];
    this.getSelectedProducts().then(() => {
      this.resetSelectedItems(false);
    });
  }

  /**
   * 重新设置选中状态（订单类型、是否管理状态改变后调用）
   * showToast: 是否显示提示
   */
  @action
  resetSelectedItems() {
    for (const cartItem of this.selectedProducts) {
      for (const item of cartItem.itemList) {
        if (this.selectedItems[item.itemSerial] && !this.getItemCanSelect(item)) {
          // 不支持订单类型的产品变为不选中
          delete this.selectedItems[item.itemSerial];
          this.selectedItems = { ...toJS(this.selectedItems) };
        }
      }
    }
  }

  /**
   * 产品列表点击勾选 (选商品)
   */
  @action
  changeSelected(itemSerial, isSelected, cartItemIndex, actId, callback) {
    let selectedItems = { ...this.selectedItems };
    selectedItems[itemSerial] = !isSelected;
    this.selectedItems = selectedItems;
    const timeout = setTimeout(() => {
      this.getDiscountBatch(() => {
        let selectedItems = { ...this.selectedItems };
        selectedItems[itemSerial] = isSelected;
        this.selectedItems = selectedItems;
      });
      const hasSelected = (this.selectedProducts[cartItemIndex].itemList || []).find(
        (item) => this.selectedItems[item.itemSerial]
      );
      if (!hasSelected) {
        delete this.modalObject[actId[cartItemIndex]];
        delete this.giftList[actId[cartItemIndex]];
        delete this.selectedGiftListItems[cartItemIndex];
        this.clearIncPriceShop([cartItemIndex]);
        callback && callback();
      } else {
        this.getIncPriceShopMsg(this.selectedProducts[cartItemIndex].gKey);
        this.handleSelectedGiftListFan(cartItemIndex, actId); // 反向自动选择赠品
        clearTimeout(timeout);
      }
    }, 0);
  }

  /**
   * 记录所有的活动id  3是赠品
   */
  @action
  selectedActivityItems(gKey = '10086', actId, type) {
    let tableObj = {
      3: 'activityGiftId'
    };
    if (this.allActivityItems[gKey]) {
      this.allActivityItems[gKey][tableObj[type]] = actId;
    } else {
      this.allActivityItems[gKey] = {};
      this.allActivityItems[gKey][tableObj[type]] = actId;
    }
  }

  /**
   * 批量计算活动分组的优惠金额
   */
  getDiscountBatch = flow(function* (callback) {
    const list = [];
    this.selectedProducts.forEach((cartItem, ind) => {
      const { activityList, itemList } = cartItem;
      const activityInfoReqDtoList = [];
      let indevalue = 0;
      let activityIdValue = [];
      for (const item of itemList) {
        if (this.selectedItems[item.itemSerial]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityList && activityList.length > 0 && this.isJoin) {
        if (activityInfoReqDtoList.length > 0) {
          list.push({
            activityInfoReqDtoList: activityList,
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
          for (const item of activityList) {
            if (+item.activityType === 3) {
              activityIdValue.push(item.activityId);
              indevalue = ind;
            }
          }
          this.handleSelectedGiftListFan(
            indevalue,
            Array.isArray(activityIdValue) ? activityIdValue.join(',') : activityIdValue
          ); // 反向自动选择赠品
        }
      } else {
        // if (this.isDiscountMode) {
        if (this.isDiscountMode || Stores.AppMod.isLD || this.memberCard) {
          list.push({
            activityInfoReqDtoList: [],
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
        }
      }
    });
    if (list.length == 0) {
      this.activityDiscountInfoListGkey = [];
      return;
    }
    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      discount: this.discount,
      orderType: this.orderType,
      dgCardno: this.memberCard
    };
    if (this.discount) {
      params.discount = this.discount;
    }
    if (this.globalSaleMode) {
      params.saleMode = this.globalSaleMode;
    }
    if (this.isXkcActivity) {
      params.saleMode = '';
    }
    try {
      const { data, resultCode, resultMsg } = yield Serv.getDiscountBatch(params);
      if (+resultCode !== 0) {
        this.handleActivityCommonTip('提示', resultMsg);
      }
      if (data && data.length > 0) {
        this.queryReturnData = data; // 将query返回的分组活动信息包含的多买多赠存到mobox;
        this.totalPureAmount = 0;
        let gKeyData = data;
        gKeyData.forEach((gItem, index) => {
          let gKey = [];
          const activityInfoReqDtoList = get(
            params,
            `calculateDiscountReqDtoList[${index}].activityInfoReqDtoList`
          );
          activityInfoReqDtoList.forEach((item, index) => {
            for (const keyIt in item) {
              if (keyIt == 'activityId') {
                gKey.push(item.activityId);
              }
            }
          });
          gItem.gKey = gKey.join('');
        });

        this.activityDiscountInfoListGkey = gKeyData;

        for (let i = 0; i < data.length; i++) {
          const groupItem = data[i];
          const { activityDiscountInfoList = [], itemDiscountInfoList = [], total = 0 } = groupItem;

          this.totalPureAmount += total;

          const activityIds = activityDiscountInfoList
            ? activityDiscountInfoList.map((item) => {
                return item.activityId;
              })
            : [];

          const { activityList, itemList } = this.selectedProducts[i];
          // 判断两个分组是否相同
          let flag = true;
          if (activityIds.length == activityList.length) {
            for (let j = 0; j < activityList.length; j++) {
              if (!activityIds.includes(activityList[j].activityId)) {
                flag = false;
                break;
              }
            }
          } else {
            flag = false;
          }

          // 找到相同分组
          if (this.isDiscountMode || flag) {
            // 设置活动项优惠
            for (const item of activityDiscountInfoList) {
              const { activityId } = item;
              for (let j = 0; j < activityList.length; j++) {
                if (activityList[j].activityId == activityId) {
                  this.selectedProducts[i].activityList[j] = {
                    ...this.selectedProducts[i].activityList[j],
                    ...item
                  };
                  break;
                }
              }
            }
            // 设置产品项优惠
            for (const item of itemDiscountInfoList) {
              const { itemSerial, discount, discountBv, price, bv, promotionBv } = item;
              for (let j = 0; j < itemList.length; j++) {
                if (itemList[j].itemSerial == itemSerial) {
                  this.selectedProducts[i].itemList[j] = {
                    ...this.selectedProducts[i].itemList[j],
                    ...{
                      discount: discount,
                      discountBv: discountBv,
                      lessBv: bv,
                      lessPrice: price,
                      promotionBv: promotionBv
                    }
                  };
                  continue;
                }
              }
            }
          }
        }
      }
    } catch (error) {
      callback && callback();
    }
  });

  /**
   * 给每个分组增加key
   */
  @action
  addActivityProductsKeys(selectedProducts) {
    // let list = []
    // let actGKey = ''

    selectedProducts.forEach((item, index) => {
      let arrActKeys = [];
      const { activityList = [] } = item;
      if (activityList.length > 0) {
        activityList.forEach((it, idx) => {
          arrActKeys.push(it.activityId);
        });
        item.gKey = arrActKeys.join('');
      }
    });

    return selectedProducts;
  }

  /**
   * 切换促销
   */
  @action
  switchActivity(list) {
    let cartIndex = -1;
    let activityIdList = [];
    list.forEach((itemValue) => {
      if (+itemValue.activityType === 3) {
        activityIdList.push(itemValue.activityId);
      }
    });
    this.selectActivityId = activityIdList; // 已选满赠活动的数组集合赋值到mobx
    for (let i = 0; i < this.selectedProducts.length; i++) {
      const { groupLabel, activityList = [] } = this.selectedProducts[i];
      const activityIds = activityList
        ? activityList.map((item) => {
            return item.activityId;
          })
        : [];
      if (`${groupLabel}` == '6') {
        let flag = true;
        if (activityIds.length == list.length) {
          for (let j = 0; j < list.length; j++) {
            if (!activityIds.includes(list[j].activityId)) {
              flag = false;
              break;
            }
          }
        } else {
          flag = false;
        }

        if (flag) {
          cartIndex = i;
          break;
        }
      }
    }

    let [cartItemIndex, itemIndex] = this.switchIndexs;
    let incPriceIndex = cartItemIndex; // 记录获取加价购组
    if (cartIndex != cartItemIndex) {
      let { selectedProducts } = this;
      const items = selectedProducts[cartItemIndex].itemList.splice(itemIndex, 1);

      if (cartIndex == -1) {
        // 新的分组, 放到数组头位
        incPriceIndex = 0;
        selectedProducts.unshift({
          activityList: list,
          groupLabel: 6,
          groupLabelName: '普通',
          itemList: items,
          mustBuyItemMap:
            selectedProducts[cartItemIndex] && selectedProducts[cartItemIndex].mustBuyItemMap
        });
        // 添加了新分组，旧的索引要+1
        cartItemIndex += 1;
      } else {
        // 没有新分组,
        incPriceIndex = cartIndex;
        selectedProducts[cartIndex].itemList.unshift(items[0]);
      }

      if (selectedProducts[cartItemIndex].itemList.length == 0) {
        // 如果删除的组在加价购组前面, 加价购组索引需要-1
        if (incPriceIndex > cartItemIndex) {
          incPriceIndex -= 1;
        }
        selectedProducts.splice(cartItemIndex, 1);
      }
      this.selectedGiftListItems = [];
      this.selectedProducts = this.addActivityProductsKeys(toJS(this.selectedProducts));

      this.selectedProducts.forEach((products, index) => {
        products.itemList.forEach((_item, _index) => {
          const { isMustBuy, limitBuyNum } = this.findProductInValidActivity(
            this.selectedProducts[index],
            _item.itemSerial
          );
          if (isMustBuy && _item.itemNum < limitBuyNum) {
            _item.itemNum = limitBuyNum;
            this.changeItemNum(_item.itemNum, index, _index, _item.itemSerial);
          }
        });
      });

      if (this.isVipRebuy) {
        this.orderType = '10';
        this.distributionRatio = '1';
      }
      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        if (this.isDiscountMode && !this.isShopMasterMode) {
          this.discount = '1';
        } else {
          this.distributionRatio = '1';
        }
        this.getSelectedProducts();
      }
      this.getIncPriceShopMsg(this.selectedProducts[incPriceIndex].gKey);
      this.getDiscountBatch();
    }
  }

  /**
   * 改变已选产品列表商品数量
   */
  @action
  changeItemNum(number, cartIndex, index, itemSerial, minNumber) {
    let selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts));
    selectedProducts[cartIndex].itemList[index].itemNum = number;
    if (number == 0 || (minNumber && number < minNumber)) {
      selectedProducts[cartIndex].itemList.splice(index, 1);
      if (selectedProducts[cartIndex].itemList.length == 0) {
        selectedProducts.splice(cartIndex, 1);
      }
    }
    this.selectedProducts = selectedProducts;
    // 修改选购产品列表数量
    let obj = toJS(Object.assign({}, this.productMsgMap));
    let { fatherItemSerial, itemNum } = obj[itemSerial];
    obj[itemSerial].itemNum = number;
    let fatherItemNum = obj[fatherItemSerial] && obj[fatherItemSerial].itemNum; // 父产品的数量
    if (fatherItemNum) {
      obj[fatherItemSerial].itemNum = fatherItemNum - itemNum + number;
    }
    if (obj[itemSerial].itemNum <= 0) {
      obj[itemSerial].selected = false;
    } else {
      obj[itemSerial].selected = true;
    }
    this.productMsgMap = obj;

    // 如果数量增减变化在延迟时间之内，并且是重复点击同一个商品，取消之前的回调，减少频繁回调请求接口
    if (this.timer && itemSerial === this.currentChangeId) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // 记录正在计时的商品
    this.currentChangeId = itemSerial;

    this.timer = setTimeout(() => {
      if (!number || number <= 0 || !Number.isInteger(number)) {
        return;
      }
      this.getDiscountBatch();
      this.getIncPriceShopMsg(this.selectedProducts[cartIndex].gKey);
    }, 1000);

    // 如果当前不是vip，重置订单类型和配货比例
    if (!this.isVipRebuy && this.orderType == '10') {
      this.orderType = '1';
      this.distributionRatio = '1';
      this.getSelectedProducts();
    }
  }

  /**
   * 加减加价购商品
   */
  @action
  changeCountIncPrice(cartItemIndex, index, count) {
    let selectedProducts = [...this.selectedProducts];
    selectedProducts[cartItemIndex].incPriceShop.items[index].itemNum = +count;
    this.selectedProducts = selectedProducts;
  }

  /**
   * 勾选加价购商品
   */
  @action
  switchIncPriceSelect(cartItemIndex, index, isSelected) {
    let selectedProducts = [...this.selectedProducts];
    const { items, maxIncPriceNum } = selectedProducts[cartItemIndex].incPriceShop;
    if (isSelected && items[index].itemNum + this.incPriceTotal.count > maxIncPriceNum) {
      Toast.info('所选数量超过限制', 3, null, false);
      return;
    }
    selectedProducts[cartItemIndex].incPriceShop.items[index].isSelected = isSelected;
    this.selectedProducts = selectedProducts;
  }

  /**
   * 加价购合计对象，包含‘总数量’、‘金额’...
   */
  @computed
  get incPriceTotal() {
    let total = [];
    this.selectedProducts.forEach((cartItem, index) => {
      total.push({ count: 0, money: 0 });
      if (cartItem.itemList.find((item) => this.selectedItems[item.itemSerial])) {
        let items = get(cartItem, 'incPriceShop.items', []);
        if (items.length > 0) {
          items.forEach((item) => {
            if (item.isSelected) {
              total[index].count += item.itemNum;
              // 指定金额加购
              if (cartItem.incPriceShop.incPriceType == 1) {
                total[index].money += item.itemNum * cartItem.incPriceShop.incPriceMoney;
              } else {
                // 指定折扣加购
                let list = [0, ...cartItem.incPriceShop.items];
                total[index].money += list.reduce((pre, next) =>
                  !next.isSelected
                    ? pre
                    : pre + next.salePrice * next.itemNum * cartItem.incPriceShop.incPriceMoney
                );
                total[index].money = +(total[index].money / 100).toFixed(2);
              }
            }
          });
        }
      }
    });
    return total;
  }

  @action
  changeSelectedAll() {
    let selectedItems = { ...this.selectedItems };
    this.selectedProducts.forEach((cartItem, index) => {
      for (const item of cartItem.itemList) {
        if (!this.isSelectedAll) {
          // 没有全选
          if (this.getItemCanSelect(item)) {
            selectedItems[item.itemSerial] = true;
          }
        } else {
          selectedItems[item.itemSerial] = false;
        }
      }
    });
    this.selectedItems = selectedItems;
    if (this.selectedProducts) {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        if (this.isSelectedAll) {
          this.getIncPriceShopMsg(this.selectedProducts[i].gKey);
        }
      }
    }

    this.getDiscountBatch(() => {
      this.changeSelectedAll();
    });
  }

  /**
   * 是否全选
   */
  @computed
  get isSelectedAll() {
    if (!this.selectedProducts || this.selectedProducts.length == 0) {
      return false;
    }

    let flag = false; // 防止一项都未选会出现全选的情况
    for (const cartItem of this.selectedProducts) {
      for (const item of cartItem.itemList) {
        if (this.getItemCanSelect(item)) {
          if (this.selectedItems[item.itemSerial]) {
            flag = true;
          } else {
            return false;
          }
        }
      }
    }
    return flag;
  }

  /**
   * 去凑单，获取活动产品列表
   */
  getActivityProductList = flow(function* (activityIdList) {
    const params = {
      activityIdList,
      orderType: this.orderType,
      discount: this.discount,
      distributionRatio: this.distributionRatio,
      dgCardno: this.memberCard
    };
    try {
      const { data, resultCode, resultMsg } = yield Serv.getActivityProductList(params);
      if (resultCode != 0) {
        Toast.fail(resultMsg, 2, null, false);
        return;
      }

      if (Array.isArray(data)) {
        set(this.menuChildMap, { _default: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 查看或收起套餐内容
   */
  @action
  showMoreCombination(cartIndex, index) {
    const { selectedProducts } = this;
    if (selectedProducts[cartIndex].itemList[index].hideMoreCombination) {
      selectedProducts[cartIndex].itemList[index].hideMoreCombination = false;
    } else {
      selectedProducts[cartIndex].itemList[index].hideMoreCombination = true;
    }
    this.selectedProducts = selectedProducts;
  }

  /**
   * 新零售 获取折扣信息
   */
  getDiscountList = flow(function* (memberCard) {
    console.log('enter discount list');
    try {
      let params = {
        orderType: 1,
        saleMode: this.globalSaleMode || ''
      };
      if (this.isXkcActivity) {
        params.saleMode = '';
      }
      if (Stores.AppMod.userInfo.userName) {
        params.shopCode = Stores.AppMod.userInfo.userName;
      }
      if (memberCard) {
        params.dgCardCode = memberCard;
        params.dgStatus = 1;
      }
      let obj = {};
      let defaultItem = {
        label: '全价',
        orderMinAmount: 0,
        value: 1
      };
      let handleDiscountMap = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          for (let i = 0; i < data.length - 1; i++) {
            for (let j = 0; j < data.length - 1 - i; j++) {
              if (+data[j].orderDiscount > +data[j + 1].orderDiscount) {
                [data[j], data[j + 1]] = [data[j + 1], data[j]];
              }
            }
          }

          distMap = data.map((item) => {
            const { orderDiscount, orderDiscountExplain, orderMinAmount } = item;

            return {
              value: orderDiscount,
              label: `${orderDiscountExplain}折`,
              orderMinAmount
            };
          });
        }
        return distMap;
      };
      const { data } = yield Serv.getDiscountList(params);
      if (data.dataType == 1) {
        obj['1'] = [...handleDiscountMap(data.lstDiscount), defaultItem];
      }

      let params_2 = {
        orderType: 2,
        saleMode: this.globalSaleMode || ''
      };
      if (this.isXkcActivity) {
        params_2.saleMode = '';
      }
      if (Stores.AppMod.userInfo.userName) {
        params_2.shopCode = Stores.AppMod.userInfo.userName;
      }
      if (memberCard) {
        params_2.dgCardCode = memberCard;
        params_2.dgStatus = 1;
      }
      const { data: data2 } = yield Serv.getDiscountList(params_2);
      if (data2.dataType == 1) {
        obj['2'] = [...handleDiscountMap(data2.lstDiscount), defaultItem];
      }
      this.discountList = obj;
      Object.keys(obj).length > 0 && this.handleDiscount();
    } catch (error) {}
  });

  /**
   * 处理折扣比例，根据接口返回设置
   */
  @action
  handleDiscount() {
    console.log('this.isQualification>>>>', this.isQualification);
    if (!this.discount) {
      if (this.isDiscountMode) {
        this.discount = this.discountList['1'][0].value;
        this.distributionRatio = 1;
        reaction(
          () => this.discount,
          (data) => {
            this.menuId &&
              (this.isQualification
                ? this.getZiGeProductList(this.menuId, false)
                : this.getProductList(this.menuId));
          }
        );
        reaction(
          () => this.orderType,
          (data) => {
            this.menuId &&
              (this.isQualification
                ? this.getZiGeProductList(this.menuId, false)
                : this.getProductList(this.menuId));
          }
        );
        this.isQualification
          ? this.getZiGeProductList(this.menuId, false)
          : this.getProductList(this.menuId);
      } else {
        this.distributionRatio = '';
      }
    }
  }

  // 订单应付满减金额/bv
  @computed
  get orderMinAmount() {
    let text = '';
    this.orderTypeList.forEach((item) => {
      if (item.value == this.orderType && this.discountList[item.value]) {
        this.discountList[item.value].forEach((subItem) => {
          if (this.discount == subItem.value) {
            text = subItem.orderMinAmount;
          }
        });
      }
    });
    return text;
  }
  // 最小金额提示
  @computed
  get minNumberTip() {
    let text = '';
    if (this.orderMinAmount > 0) {
      if (this.orderType * 1 == 1) {
        text = `订单应付满${Util.formatMoney({ value: this.orderMinAmount, showPrefix: false, showCurrencyName: true, precision: 0 })}可用`;
      } else {
        text = `订单应付满${this.orderMinAmount}BV可用`;
      }
    }

    return text;
  }

  /**
   * 获取用户支持的配货比例，存入userInfo
   */
  // getUserdistriBution = flow(function*() {
  //   if (!this.token) {
  //     return;
  //   }
  //   try {
  //     const { data } = yield Serv.getUserdistriBution({orderType: 1});
  //     // let distributionRatioList = [];
  //     let obj = {};
  //     let defaultItem = {
  //       label: '未选择',
  //       orderMinAmount: 0,
  //       value: '-1',
  //     };
  //     let handleDistriBution = (data) => {
  //       let distMap = [];
  //       if (data && data.length > 0) {
  //         // 按从小到大排序
  //         for (let i = 0; i < data.length - 1; i++) {
  //           for (let j = 0; j < data.length - 1 - i; j++) {
  //             if (+data[j].orderProperty > +data[j + 1].orderProperty) {
  //               [data[j], data[j + 1]] = [data[j + 1], data[j]];
  //             }
  //           }
  //         }

  //         distMap = data.map(item => {
  //           const { orderProperty, orderPropertyName, orderMinAmount } = item;

  //           return { value: orderProperty, label: `${orderPropertyName} 配货`, orderMinAmount };
  //         });
  //       }
  //       return distMap;
  //     };
  //     obj['1'] = [defaultItem, ...handleDistriBution(data)];
  //     const { data: data2 } = yield Serv.getUserdistriBution({orderType: 2});
  //     obj['2']  = [defaultItem, ...handleDistriBution(data2)];

  //     this.userInfo = { ...this.userInfo, distributionRatioList: obj };
  //     Util.setLocalCache(Config.localStorageKeys.member_userInfo, this.userInfo);
  //   } catch (error) {}
  // });

  // 获取资格购列表
  getQualificationList2 = flow(function* () {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getQualificationList({
        isPurchasingAgent: 0
      });
      if (resultCode == 0 && data) {
        return data || [];
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  });

  /**
   * 查询资格购活动
   * 判断用户是否有当前资格购活动的资格
   */
  getActivityInfo = flow(function* (activityId) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getActivityInfo(activityId);
      if (resultCode == 0 && data) {
        return data;
      }
      return false;
    } catch (err) {
      return false;
    }
  });

  /**
   * 校验复消专区资格
   */
  checkActivity = flow(function* (activityId) {
    const params = {
      activityId
    };
    if (this.memberId) {
      params.dgUserId = this.memberId;
    }
    try {
      const result = yield Serv.checkActivity(params);
      if (result && result.resultCode == '0') {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 获取卡级别
   */
  getCardList = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getCardList();
      if (resultCode == 0) {
        runInAction(() => {
          let currentData = (data.list || []).find((item) => item.type === data.cardType);
          if (currentData) {
            this.currentCardTypeName = currentData.name;
          }
          this.currentCardType = data.cardType;
          this.hadAccumulateAmount = data.hadAccumulateAmount;
        });
      }
    } catch (error) {}
  });

  /**
   * 获取客的卡级别
   */
  getDgCardList = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getDgCardList(params);
      if (resultCode == 0) {
        runInAction(() => {
          this.currentCardTypeName = data.cardTypeName;
          this.currentCardType = data.cardType;
          this.hadAccumulateAmount = data.hadAccumulateAmount;
        });
      }
    } catch (error) {
      console.log('err', error);
    }
  });

  @action
  clearData() {
    this.orderType = '1';
    this.distributionRatio = '';
    this.discount = '';
    this.discountList = [];
    this.menuList = [];
    this.menuChildMap = { _default: [] };
    this.productMsgMap = {};
    this.menuId = '';
    this.activeKeys = ['', '', ''];
    this.menuTitle = '';
    this.detailId = '';
    this.keyword = '';
    this.showDetail = false;
    this.selectedProducts = [];
    this.tabIndex = 0;
    this.selectedItems = {};
    this.isJoin = true;
    this.switchIndexs = [];
    this.isScrape = false;
    this.storeDistributionList = null;
    this.activityId = '';
    this.realDistributeRadioList = '';
    this.isQualificationSearch = false;
    this.searchList = [];
    this.showLeftTree = false;
    this.counponQuickBuy = false;
    this.qualificationList = [];
    this.leftClassify = '';
    this.webTitle = '';
    this.currentCardType = '';
    this.hadAccumulateAmount = 0;
    this.currentCardTypeName = '';
    this.globalSaleMode = null;
    this.selectedGiftListItems = [];
    this.isXkcActivity = false;
  }

  /**
   * 清除加价购数据
   */
  @action
  clearIncPriceShop(indexs) {
    for (let index of indexs) {
      this.selectedProducts[index].incPriceShop = null;
    }
  }
}
const quickBuyMod = new QuickBuyMod();
export default quickBuyMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyMod.js